import { Events } from './events'

const pendingGetRequests = new Map()

class Network {
  static initNetworkStateListener() {
    let isClient = false
    try {
      if (window) isClient = true
    } catch (error) {
      console.log(error)
    }
    if (!isClient) return
    if (navigator.onLine) {
      Events.dispatchEvent('online')
    } else {
      Events.dispatchEvent('offline')
    }
    window.addEventListener('online', function () {
      console.log('I am connected to the internet')
      Events.dispatchEvent('online')
    })

    window.addEventListener('offline', function () {
      console.log('Disconnected...so sad!!!')
      Events.dispatchEvent('offline')
    })
  }

  static initListenerForServiceWorker() {
    self.isConnected = true
    Events.handleEvent('online', () => {
      self.isConnected = true
    })
    Events.handleEvent('offline', () => {
      self.isConnected = false
    })
  }

  static sendRequestTo(url, data, method) {
    return request(method, url, null, data)
  }

  static sendGetRequest(url) {
    return request('get', url)
  }

  static sendGetRequestWithHeader(url, header) {
    return request('get', url, header)
  }

  static sendPostRequest(url, data) {
    return request('post', url, null, data)
  }

  static sendPutRequest(url, data) {
    return request('put', url, null, data)
  }

  static sendPutRequestWithHeader(url, header, data) {
    return request('put', url, header, data)
  }

  static sendDeleteRequest(url, data) {
    return request('delete', url, null, data)
  }

  static sendPostRequestWithHeader(url, header, data) {
    return request('post', url, header, data)
  }

  static defaultResponseParsing(response) {
    let parsed = {
      success: false,
      messageId: 'messages.unknownError',
    }
    if (response.status.code === 503) {
      parsed = {
        success: false,
        messageId: 'messages.serverNotAvailale',
      }
    } else if (response.status.code === 'not_connected') {
      parsed = {
        success: false,
        messageId: 'messages.badNetwork',
        networkError: true,
      }
    }
    // console.warn(parsed, response)
    return parsed
  }
}

async function request(method, url, headers = null, data = null) {
  if (method.toLowerCase() === 'get') {
    const cacheKey = url + JSON.stringify(headers || {})

    if (pendingGetRequests.has(cacheKey)) {
      const { promise, timestamp } = pendingGetRequests.get(cacheKey)
      const now = Date.now()
      if (now - timestamp < 10000) {
        return promise
      }
    }

    const newPromise = doRequest(method, url, headers, data)
    pendingGetRequests.set(cacheKey, {
      promise: newPromise,
      timestamp: Date.now(),
    })

    newPromise.finally(() => {
      pendingGetRequests.delete(cacheKey)
    })

    return newPromise
  }

  return doRequest(method, url, headers, data)
}

async function doRequest(method, url, headers = null, data = null) {
  const start = Date.now()
  const requestConfig = {
    method,
    headers: {
      'Content-Type': 'application/json',
      ...(headers || {}),
    },
  }
  if (data) requestConfig.body = JSON.stringify(data)

  let dataToReturn = {
    status: { code: 'not_connected' },
    response: null,
  }

  try {
    const response = await fetch(url, requestConfig)
    dataToReturn = {
      status: { code: response.status },
      response: await response.json(),
    }
  } catch (error) {
    console.warn(error)
  }

  const end = Date.now()
  const duration = (end - start) / 1000

  Events.dispatchEvent('network_request_end', {
    durationSec: duration,
    method,
    url,
  })

  return dataToReturn
}

export { Network }
